import { InjectionToken } from '@angular/core';

import { BrandThemesEnum, ImageRatioEnum, PositionEnum, SizesEnum, ThemesEnum } from '@seb/web-design-system/core';
import { ArgumentsLayoutEnum } from '@seb/web-design-system/arguments';

export interface WcConfig {
  isRecipesEnabled?: boolean;
  categoryPage?: CategoryPageConfig;
  subCategoryPage?: SubCategoryPageConfig;
  pdp?: PdpConfig;
  accessoryPage?: AccessoryPageConfig;
  recipeDetailsPage?: RecipeDetailsPageConfig;
  isThemeDark?: boolean;
  reinssurance?: LameConfig;
  isArgumentUnderlined?: boolean;
  warranty?: string;
  sliderCategoryOnly?: boolean;
  isNoIndexEnabled?: boolean;
  iconPos?: PositionEnum.left | PositionEnum.right;
  isTeaserEmbedded?: boolean;
  linkCardSubcategories?: boolean;
}

export interface PdpConfig {
  bundlesOrProducts?: LameConfig;
  designedFor?: LameConfig;
  productInfoArguments?: LameConfig;
  benefits?: LameConfig;
  range?: LameConfig;
  recipes?: LameConfig;
  comparator?: LameConfig;
  freeEditoLocalArguments?: LameConfig;
  freeEditoBUArguments?: LameConfig;
  howTo?: LameConfig;
  replacementParts?: LameConfig;
  ifu?: LameConfig;
  faqs?: LameConfig;
  disclaimer?: LameConfig;
  accessories?: LameConfig;
  crossSell?: LameConfig;
  reviews?: LameConfig;
}

export interface LameConfig {
  textConfig?: PositionEnum.center | PositionEnum.left | PositionEnum.right;
  mediaConfig?: PositionEnum;
  theme?: ThemesEnum | BrandThemesEnum;
  backgroundTheme?: ThemesEnum | BrandThemesEnum;
  layout?: ArgumentsLayoutEnum;
  argumentsLayout?: ArgumentsLayoutEnum;
  titleTextConfig?: PositionEnum.center | PositionEnum.left | PositionEnum.right;
  titleTheme?: ThemesEnum.light | ThemesEnum.dark | BrandThemesEnum.brand;
  pushSize?: SizesEnum;
  pushImageRatio?: ImageRatioEnum;
  pushTextConfig?: PositionEnum.center | PositionEnum.left | PositionEnum.right;
  pushMediaConfig?: PositionEnum;
  pushTheme?: ThemesEnum | BrandThemesEnum;
  hasGradient?: boolean;
  titleUnderlined?: boolean;
  pushTitleTheme?: ThemesEnum | BrandThemesEnum;
  hasSubline?: boolean;
}

export interface CategoryPageConfig {
  lame1?: LameConfig;
  lame4?: LameConfig;
  faq?: LameConfig;
  lame7?: LameConfig;
}

export interface SubCategoryPageConfig {
  lame1?: LameConfig;
  lame4?: LameConfig;
  lame5?: LameConfig;
  lame7?: LameConfig;
  lame8?: LameConfig;
  lame9?: LameConfig;
  lame10?: LameConfig;
  lame11?: LameConfig;
}

export interface AccessoryPageConfig {
  categories?: AccessoryContentConfig;
  search?: AccessoryContentConfig;
}

export interface AccessoryContentConfig {
  backgroundTheme?: ThemesEnum | BrandThemesEnum;
  titleTheme?: ThemesEnum.light | ThemesEnum.dark | BrandThemesEnum.brand;
}
export interface RecipeDetailsPageConfig {
  reviews?: LameConfig;
}

export const WC_CONFIG_PROVIDER = new InjectionToken<WcConfig>('WC_CONFIG_PROVIDER');
